import React, { useEffect, useState, useRef, createElement } from 'react';
import { CheckCircle2 } from 'lucide-react';
function CountdownTimer() {
  const [seconds, setSeconds] = useState(5 * 60 + 59);
  useEffect(() => {
    if (seconds <= 0) return;
    const interval = setInterval(() => setSeconds(s => s - 1), 1000);
    return () => clearInterval(interval);
  }, [seconds]);
  const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
  const secs = (seconds % 60).toString().padStart(2, '0');
  return <span className="font-mono font-bold text-white text-xs md:text-base tracking-wider" data-id="element-761">
      {mins}:{secs}
    </span>;
}
declare global {
  interface Window {
    checkoutElements: any;
  }
}
function HotmartSalesFunnel() {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const scriptId = 'hotmart-checkout-elements';
    const mount = () => {
      if (window.checkoutElements && containerRef.current) {
        containerRef.current.innerHTML = '';
        window.checkoutElements.init('salesFunnel').mount(containerRef.current);
      }
    };
    if (document.getElementById(scriptId)) {
      mount();
      return;
    }
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://checkout.hotmart.com/lib/hotmart-checkout-elements.js';
    script.async = true;
    script.onload = mount;
    document.head.appendChild(script);
  }, []);
  return <div ref={containerRef} id="hotmart-sales-funnel" data-id="element-762"></div>;
}
export function UpsellPage() {
  return <div className="h-[100dvh] bg-brand-bg flex flex-col overflow-hidden" data-id="element-763">
      {/* Top Urgency Banner */}
      <div className="bg-brand-gold text-brand-bg text-center py-1.5 px-3 relative shrink-0" data-id="element-764">
        <p className="font-bold text-[11px] md:text-sm relative z-10 leading-tight" data-id="element-765">
          ¡ESPERA! Añade el Blindaje Completo y Ahorra 64%
        </p>
        <div className="flex items-center justify-center gap-1.5 relative z-10" data-id="element-766">
          <span className="text-brand-bg/70 text-[9px] md:text-xs" data-id="element-767">
            Expira en:
          </span>
          <CountdownTimer data-id="element-768" />
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center px-2.5 md:px-6 py-1.5 md:py-4" data-id="element-769">
        <div className="w-full max-w-3xl bg-brand-card border border-brand-gold/15 rounded-xl overflow-hidden shadow-2xl shadow-black/30" data-id="element-770">
          {/* Product Section */}
          <div className="p-3 md:p-6" data-id="element-771">
            <div className="flex flex-row gap-3 md:gap-6 items-start" data-id="element-772">
              {/* Product Image — always side by side */}
              <div className="shrink-0 w-[100px] md:w-[200px]" data-id="element-773">
                <img src="https://cdn.magicpatterns.com/uploads/heHq34LacWwP9HLREsF36Z/Blindaje_Capital_COver.png" alt="Blindaje de Capital y Soberanía Digital" className="w-full rounded-lg shadow-lg border border-brand-gold/10" data-id="element-774" />
              </div>

              {/* Product Info */}
              <div className="flex-1 space-y-1.5 md:space-y-3" data-id="element-775">
                <h1 className="text-sm md:text-xl font-bold text-white font-serif leading-tight" data-id="element-776">
                  Blindaje de Capital y Soberanía Digital ante el Nuevo Orden
                  Global
                </h1>

                <div className="flex items-center gap-2 flex-wrap" data-id="element-777">
                  <span className="text-brand-muted line-through text-xs md:text-base" data-id="element-778">
                    $47.00
                  </span>
                  <span className="text-brand-gold font-bold text-lg md:text-2xl" data-id="element-779">
                    $17.00
                  </span>
                  <span className="bg-brand-green/20 text-brand-green text-[9px] md:text-xs font-bold px-1.5 py-0.5 rounded border border-brand-green/30" data-id="element-780">
                    64% OFF
                  </span>
                </div>

                <p className="text-brand-text/85 text-[11px] md:text-sm leading-snug hidden md:block" data-id="element-781">
                  Ya tomaste la mejor decisión aprendiendo las reglas del
                  dinero. Ahora protege lo que estás construyendo con{' '}
                  <strong className="text-white" data-id="element-782">
                    Blindaje de Capital y Soberanía Digital
                  </strong>{' '}
                  — el sistema exacto para blindar tu patrimonio ante la crisis
                  global que ya comenzó.
                </p>
              </div>
            </div>

            {/* Mobile-only short copy */}
            <p className="text-brand-text/85 text-[11px] leading-snug mt-2 md:hidden" data-id="element-783">
              Protege lo que estás construyendo con el sistema exacto para
              blindar tu patrimonio ante la crisis global.
            </p>

            {/* Benefits */}
            <div className="space-y-1 mt-2 md:mt-3" data-id="element-784">
              <div className="flex items-start gap-1.5" data-id="element-785">
                <CheckCircle2 className="w-3.5 h-3.5 text-brand-green shrink-0 mt-px" data-id="element-786" />
                <span className="text-brand-text/90 text-[11px] md:text-sm leading-tight" data-id="element-787">
                  Protocolo para proteger tu capital ante devaluación e
                  inflación
                </span>
              </div>
              <div className="flex items-start gap-1.5" data-id="element-788">
                <CheckCircle2 className="w-3.5 h-3.5 text-brand-green shrink-0 mt-px" data-id="element-789" />
                <span className="text-brand-text/90 text-[11px] md:text-sm leading-tight" data-id="element-790">
                  Sistema de diversificación para no depender de un solo banco o
                  moneda
                </span>
              </div>
              <div className="flex items-start gap-1.5" data-id="element-791">
                <CheckCircle2 className="w-3.5 h-3.5 text-brand-green shrink-0 mt-px" data-id="element-792" />
                <span className="text-brand-text/90 text-[11px] md:text-sm leading-tight" data-id="element-793">
                  Guía de soberanía digital para blindar tus cuentas y
                  operaciones
                </span>
              </div>
            </div>
          </div>

          {/* Order Summary */}
          <div className="border-t border-brand-gold/10 bg-brand-bg/50 px-3 md:px-6 py-2 md:py-3" data-id="element-794">
            <div className="max-w-xs ml-auto space-y-1" data-id="element-795">
              <div className="flex items-center justify-between text-[11px] md:text-sm" data-id="element-796">
                <span className="text-brand-muted" data-id="element-797">Subtotal</span>
                <span className="text-white font-medium" data-id="element-798">$17.00</span>
              </div>
              <div className="flex items-center justify-between text-[11px] md:text-sm" data-id="element-799">
                <span className="text-brand-muted" data-id="element-800">Impuestos</span>
                <span className="text-brand-muted" data-id="element-801">N/A</span>
              </div>
              <div className="border-t border-brand-gold/15 pt-1.5 flex items-center justify-between" data-id="element-802">
                <span className="text-white font-bold text-xs md:text-sm" data-id="element-803">
                  Total
                </span>
                <span className="text-white font-bold text-sm md:text-lg" data-id="element-804">
                  USD $17.00
                </span>
              </div>
            </div>
          </div>

          {/* Hotmart Sales Funnel Widget */}
          <div className="px-3 md:px-6 pb-3 pt-1" data-id="element-805">
            <HotmartSalesFunnel data-id="element-806" />
          </div>
        </div>
      </div>
    </div>;
}